<template>
  <!--地址组件  -->
  <div class="con border_bottom1px_shadow clearfix" @click="showAddress">
    <div class="left font12 font_weight400 colo055 color_select text_left">
      配送
    </div>
    <div class="left font12 font_weight400 colo087 text_left color_color">
      <div>浙江省 杭州市 滨江区英飞特大厦E座</div>
      <div class="font10 font_weight400 colo055 add_det">
        如需暂停或取消配送计划，请提前申请17点之前完成支付，预计8月29日送达
      </div>
    </div>
    <img
      src="@/assets/common/icon_back_b87_24@2x.png"
      alt=""
      class="right color_right"
    />
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    showAddress() {
      this.$emit("showAddress");
    }
  }
};
</script>
<style lang="less" scoped>
.con {
  padding: 7px 0 10px;
  .color_select {
    line-height: 17px;
    margin: 4px 20px 0 0;
  }
  .color_color {
    line-height: 17px;
    margin-top: 4px;
    width: 250px;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .color_right {
    width: 24px;
  }
  .add_det {
    width: 200px;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 6;
    -webkit-box-orient: vertical;
    margin-top: 4px;
  }
}
</style>
